module.exports = __webpack_public_path__ + "img/6.8423fd63.jpg";